import React from "react";
import { ErrorPage } from "../errorPage";

export const PageNotFound = ({ errorTitle = "Page not found" }) => {
	const description = (
		<span>
			Page not found or you do not have <br /> enough permissions to
			access it
		</span>
	);
	return <ErrorPage title={errorTitle} description={description} />;
};
